import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/materials',
  component: Management,
  redirect: '/materials/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/materials/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listMaterials
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/materials/ListTable'),
          meta: {
            auth: Auth.listMaterials,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/materials/ListTable'),
          meta: {
            auth: Auth.listMaterials,
            tabName: 'pending'
          }
        },
        {
          path: 'passed',
          component: () => import('@/views/materials/ListTable'),
          meta: {
            auth: Auth.listMaterials,
            tabName: 'passed'
          }
        },
        {
          path: 'rejected',
          component: () => import('@/views/materials/ListTable'),
          meta: {
            auth: Auth.listMaterials,
            tabName: 'rejected'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/materials/New'),
      meta: {
        auth: Auth.createMaterial
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/materials/Edit'),
      meta: {
        auth: Auth.updateMaterial
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/materials/DetailLayout'),
      meta: {
        auth: Auth.showMaterial
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/materials/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showMaterial
          }
        }
      ]
    }
  ]
}
